import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <article className="panel">
      <h1>Page not found</h1>
      <p>This URL is not part of the static site map.</p>
      <p>
        <Link to="/">Return to catalog</Link>
      </p>
    </article>
  );
}
